import { Controller } from "@hotwired/stimulus"

// Focus-aware activity heartbeat. While THIS tab is visible and the user
// has interacted within IDLE_AFTER, POST /activity/heartbeat every
// INTERVAL. The server turns the gaps between beats into "active time"
// (an admin-only metric). We simply stop pinging when the tab is hidden or
// the user goes idle; the server reads the resulting gap as idle time and
// doesn't count it. Attached to <body> only for authenticated users.
const INTERVAL   = 60000    // ms between beats
const IDLE_AFTER = 120000   // ms since last input before we treat as idle

export default class extends Controller {
  connect() {
    this.lastInput = Date.now()
    this.token = document.querySelector('meta[name="csrf-token"]')?.content || ""
    this.onInput = () => { this.lastInput = Date.now() }
    this.events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "pointerdown"]
    this.events.forEach(e => document.addEventListener(e, this.onInput, { passive: true }))
    this.timer = setInterval(() => this.beat(), INTERVAL)
  }

  disconnect() {
    if (this.timer) { clearInterval(this.timer); this.timer = null }
    this.events?.forEach(e => document.removeEventListener(e, this.onInput))
  }

  beat() {
    if (document.visibilityState !== "visible") return
    if (Date.now() - this.lastInput > IDLE_AFTER) return
    fetch("/activity/heartbeat", {
      method: "POST",
      headers: { "X-CSRF-Token": this.token, "Accept": "application/json" },
      credentials: "same-origin",
      keepalive: true
    }).then((res) => {
      if (res.status === 401 || res.status === 403) this.disconnect()  // auth gone — stop
    }).catch(() => {})
  }
}
